// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Addcategory_pageWrap__6\\+Gfn {
  padding: 4px 4px 32px;
}

/* =========================================================
   Toolbar card (create / update category)
   ========================================================= */
.Addcategory_toolbarCard__p3Z9u {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  background: #ffffff;
  border: 1px solid #E7E9F1;
  border-radius: 16px;
  padding: 20px 24px;
  margin: 16px 0 20px;
  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);
}

.Addcategory_field__epVqM {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 260px;
  flex: 1 1;
}

.Addcategory_fieldSmall__xPxMk {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
}

.Addcategory_label__VCgxJ {
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.Addcategory_required__jX5W\\+ {
  color: #EF4444;
  margin-left: 2px;
}

.Addcategory_errorText__thC3N {
  font-size: 11.5px;
  color: #EF4444;
  font-weight: 600;
}

.Addcategory_input__5VciH,
.Addcategory_select__Pa8vu {
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 14px;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.Addcategory_input__5VciH:focus,
.Addcategory_select__Pa8vu:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.Addcategory_saveBtn__CkJh- {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 11px 28px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.Addcategory_saveBtn__CkJh-:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);
}

.Addcategory_updateBtn__\\+o1BV {
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 11px 28px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.Addcategory_updateBtn__\\+o1BV:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(22, 163, 74, 0.34);
}
`, "",{"version":3,"sources":["webpack://./src/pages/New Category/Addcategory.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Toolbar card (create / update category)\n   ========================================================= */\n.toolbarCard {\n  display: flex;\n  align-items: flex-end;\n  gap: 20px;\n  flex-wrap: wrap;\n  background: #ffffff;\n  border: 1px solid #E7E9F1;\n  border-radius: 16px;\n  padding: 20px 24px;\n  margin: 16px 0 20px;\n  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 260px;\n  flex: 1;\n}\n\n.fieldSmall {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 180px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.required {\n  color: #EF4444;\n  margin-left: 2px;\n}\n\n.errorText {\n  font-size: 11.5px;\n  color: #EF4444;\n  font-weight: 600;\n}\n\n.input,\n.select {\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 14px;\n  background: #ffffff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.input:focus,\n.select:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.saveBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 11px 28px;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.saveBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);\n}\n\n.updateBtn {\n  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 11px 28px;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.28);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.updateBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(22, 163, 74, 0.34);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Addcategory_pageWrap__6+Gfn`,
	"toolbarCard": `Addcategory_toolbarCard__p3Z9u`,
	"field": `Addcategory_field__epVqM`,
	"fieldSmall": `Addcategory_fieldSmall__xPxMk`,
	"label": `Addcategory_label__VCgxJ`,
	"required": `Addcategory_required__jX5W+`,
	"errorText": `Addcategory_errorText__thC3N`,
	"input": `Addcategory_input__5VciH`,
	"select": `Addcategory_select__Pa8vu`,
	"saveBtn": `Addcategory_saveBtn__CkJh-`,
	"updateBtn": `Addcategory_updateBtn__+o1BV`
};
export default ___CSS_LOADER_EXPORT___;
